"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateTransactionDto = void 0;
class CreateTransactionDto {
    advertismentId;
    amount;
    campaignId;
    currency;
    data;
    displayId;
    /**
     * @deprecated
     */
    gifId;
    mediaId;
    operationKey;
    /**
     * @deprecated
     */
    overlayId;
    gateway;
    paymentGatewayTxId;
    /**
     * @deprecated
     */
    reactionId;
    reason;
    ref;
    status;
    stripeEventId;
    type;
    userId;
    walletId;
    walletOwnerId;
}
exports.CreateTransactionDto = CreateTransactionDto;
